// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/type/addons.proto (package wisetime.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/type/addons.proto.
 */
export const file_wisetime_type_addons: GenFile = /*@__PURE__*/
  fileDesc("Chp3aXNldGltZS90eXBlL2FkZG9ucy5wcm90bxINd2lzZXRpbWUudHlwZSIsCg1TZXJ2aWNlQWRkT25zEhsKE25hcnJhdGVfZ3B0X2VuYWJsZWQYASABKAhCJgoVY29tLndpc2V0aW1lLmFwaS50eXBlQgtBZGRPbnNQcm90b1ABYgZwcm90bzM");

/**
 * @generated from message wisetime.type.ServiceAddOns
 */
export type ServiceAddOns = Message<"wisetime.type.ServiceAddOns"> & {
  /**
   * if true, user is permitted to use NarrateGPT (assisted narration service)
   *
   * @generated from field: bool narrate_gpt_enabled = 1;
   */
  narrateGptEnabled: boolean;
};

/**
 * Describes the message wisetime.type.ServiceAddOns.
 * Use `create(ServiceAddOnsSchema)` to create a new message.
 */
export const ServiceAddOnsSchema: GenMessage<ServiceAddOns> = /*@__PURE__*/
  messageDesc(file_wisetime_type_addons, 0);

